export const isGoogleBot = () => {
  const userAgent =
    (typeof navigator !== 'undefined' && navigator?.userAgent?.toLowerCase()) ||
    '';
  return /bot|googlebot|lighthouse|crawler|spider|robot|crawling/i.test(
    userAgent
  );
};
